// reducers.js
import { SET_URL, SET_USER_DETAILS, SET_VERIFY_PAYMENT } from "./action";

// Helper function to extract gId from URL
// const extractgId = (url) => {
//   const parts = url.split("/");
//   return parts.length > 1 ? parts[parts.length - 1] : "";
// };
const extractIds = (url) => {
  try {
    const { pathname } = new URL(url);
    const parts = pathname.split("/").filter(Boolean);
    const gId = parts[0] || "";
    const dueId = parts[1] || "";
    return { gId, dueId };
  } catch (error) {
    // fallback if URL is not absolute
    const parts = url.split("/").filter(Boolean);
    const gId = parts[0] || "";
    const dueId = parts[1] || "";
    return { gId, dueId };
  }
};

// Helper function to get saved data from session storage
const getSavedData = () => {
  // const savedgId = sessionStorage.getItem("gId");
  const savedgId = sessionStorage.getItem("gId");
  const savedDueId = sessionStorage.getItem("dueId");
  const savedDetails = sessionStorage.getItem("userDetails");
  const savedPayment = sessionStorage.getItem("paymentRecipt");
  return {
    // gId: savedgId ? JSON.parse(savedgId) : "",
    gId: savedgId ? JSON.parse(savedgId) : "",
    dueId: savedDueId ? JSON.parse(savedDueId) : "",
    userDetails: savedDetails ? JSON.parse(savedDetails) : null,
    paymentRecipt: savedPayment ? JSON.parse(savedPayment) : null,
  };
};

// Initial state with data from session storage
const initialState = {
  // gId: getSavedData().gId,
  gId: getSavedData().gId,
  dueId: getSavedData().dueId,
  userDetails: getSavedData().userDetails,
  paymentRecipt: getSavedData().paymentRecipt,
};

const urlReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_URL:
      // const gId = extractgId(action.payload);
      // sessionStorage.setItem("gId", JSON.stringify(gId));
      const { gId, dueId } = extractIds(action.payload);
      sessionStorage.setItem("gId", JSON.stringify(gId));
      sessionStorage.setItem("dueId", JSON.stringify(dueId));
      return {
        ...state,
        gId,
        dueId,
      };

    case SET_USER_DETAILS:
      sessionStorage.setItem("userDetails", JSON.stringify(action.payload));
      return {
        ...state,
        userDetails: action.payload,
      };

    case SET_VERIFY_PAYMENT:
      sessionStorage.setItem("verifyPayment", JSON.stringify(action.payload));
      return {
        ...state,
        verifyPayment: action.payload,
      };

    default:
      return state;
  }
};

export default urlReducer;
